/**
 * Editor callback props shared by decision and task nodes.
 */
export default function sharedEditorCallbacks(props, handlers) {
  const {
    onStatusChange,
    onCategoryChange,
    onAddTag,
    onRemoveTag,
    onSetPrimaryTag,
    onIconChange,
    onIconDeleted,
    onTaskResize,
    onTaskResizeEnd,
    onTaskResetSize,
    onAddStatus,
    onDeleteStatus,
    onRenameStatus,
    onRenameCategory,
    onDeleteCategory,
    onRenameTag,
    onDeleteTag,
    onDueDateChange,
    onRemindersChange,
    onEstimatedDurationMinutesChange,
    onCreatedAtChange,
    onStartedAtChange,
    onCompletedAtChange,
    onUpdatedAtChange,
    onPriorityChange,
    onDifficultyChange,
    onCustomFieldValueChange,
    customFields,
    onArchiveTask,
    onUnarchiveTask,
    onAddMilestoneOnHost,
    onAddNoteOnHost,
    onCreateParallelMission,
    onInsertMissionBefore,
    onConditionsChange,
    onConditionsDialogOpen,
    onConditionsDialogClose,
    onOpenDetails,
    onOpenAttachments,
    centerOnTask,
    handleCreateConnectedNode,
    hasClipboardData,
    onCreateCampaign,
    isMultiCampaignMode,
    cardDisplaySettings,
    isTemplate,
    currentView,
    customViews,
    activeCustomViewId,
    onViewChange,
    onSelectCustomView,
    onGoToTaskInView,
    onSubmitDeliverable,
    onEditDeliverables,
    onClearDeliverable,
    onNavigateToParentMission,
  } = props;

  return {
    onStatusChange,
    onCategoryChange,
    onAddTag,
    onRemoveTag,
    onSetPrimaryTag,
    onIconChange,
    onIconDeleted,
    onResize: onTaskResize,
    onResizeEnd: onTaskResizeEnd,
    onResetSize: onTaskResetSize,
    onDelete: handlers.onDelete,
    onCopy: handlers.onCopy,
    onDuplicate: handlers.onDuplicate,
    onFocusTask: handlers.onFocusTask,
    onAddStatus,
    onDeleteStatus,
    onRenameStatus,
    onRenameCategory,
    onDeleteCategory,
    onRenameTag,
    onDeleteTag,
    onDueDateChange,
    onRemindersChange,
    onEstimatedDurationMinutesChange,
    onCreatedAtChange,
    onStartedAtChange,
    onCompletedAtChange,
    onUpdatedAtChange,
    onPriorityChange,
    onDifficultyChange,
    onCustomFieldValueChange,
    customFields,
    onArchiveTask,
    onUnarchiveTask,
    onAddMilestoneOnHost,
    onAddNoteOnHost,
    onCreateParallelMission,
    onInsertMissionBefore,
    onConditionsChange,
    onConditionsDialogOpen,
    onConditionsDialogClose,
    onOpenDetails,
    onOpenAttachments,
    onGoToTask: centerOnTask,
    onCreateConnectedNode: handleCreateConnectedNode,
    checkClipboard: hasClipboardData,
    onCreateCampaign,
    isMultiCampaignMode,
    cardDisplaySettings,
    isTemplate,
    currentView,
    customViews,
    activeCustomViewId,
    onViewChange,
    onSelectCustomView,
    onGoToTaskInView,
    onSubmitDeliverable,
    onEditDeliverables,
    onClearDeliverable,
    onNavigateToParentMission,
  };
}
